import React from 'react';

const TiktokFeeds = () => {
  return <div>Tiktok Feeds</div>;
};

export default TiktokFeeds;
